import React, { useState } from 'react';
import RadioGroup from './components/RadioGroup/RadioGroupForm';
import './Form.css';

function App() {
  const [formData, setFormData] = useState({ type: "" , membreDuGroupe: ""});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (eOrName, maybeValue) => { if (eOrName && eOrName.target) {
     const { name, value } = eOrName.target; setFormData((prev) => ({ ...prev, [name]: value, })); }
  else if (typeof eOrName === "string") { setFormData((prev) => ({ ...prev, [eOrName]: maybeValue, })); }
};
  const handleSubmit = async (e) => { e.preventDefault(); 
    // Nettoyage des champs non pertinents selon le type
     const payload = { ...formData }; if (payload.type === 'activite') { 
        delete payload.organisateurEvenement; delete payload.lieuEvenement;
        delete payload.dateEv; delete payload.titreEvenement; delete payload.EvParticipantCea;
        delete payload.EvParticipantAutre; delete payload.domaineEvenement; delete payload.nomEvenement;
        delete payload.organismeSeance; delete payload.lieuSeance; delete payload.reunionSeance;
        delete payload.dateSeance; delete payload.HeureSeance; delete payload.participantCea;
        delete payload.observationSeance;

    } 
     else if (payload.type === 'evenement') { 
        delete payload.organismeSeance;delete payload.lieuSeance; delete payload.reunionSeance;
        delete payload.dateSeance; delete payload.HeureSeance;
        delete payload.participantCea;delete payload.observationSeance;
        delete payload.titreActivite; delete payload.descActivite;
        delete payload.dateDebutActivite; delete payload.dateFinActivite;
        delete payload.dureeActivite; delete payload.partenaireActivite;
        delete payload.beneficiaireActivite; delete payload.nombreBeneficiaireActivite;
        delete payload.regionActivite; delete payload.villeActivite; delete payload.activiteEnEquipe;
        delete payload.membreDuGroupe; delete payload.observationActivite;
      } 
     else if (payload.type === 'seance') { 
        delete payload.organisateurEvenement; delete payload.lieuEvenement;
        delete payload.dateEv; delete payload.titreEvenement;
        delete payload.EvParticipantCea; delete payload.EvParticipantAutre;
        delete payload.domaineEvenement; delete payload.nomEvenement;
        delete payload.titreActivite; delete payload.descActivite;
        delete payload.dateDebutActivite; delete payload.dateFinActivite;
        delete payload.dureeActivite; delete payload.partenaireActivite;
        delete payload.beneficiaireActivite; delete payload.nombreBeneficiaireActivite;
        delete payload.regionActivite; delete payload.villeActivite; delete payload.activiteEnEquipe;delete payload.membreDuGroupe;
        delete payload.observationActivite;
      } 
      setSubmitted(true);
      setFormData({ type: "" , membreDuGroupe: "" });
     const res = await fetch('https://survey-fop.group-cea.org/responses', { method: 'POST', headers: { 'Content-Type': 'application/json' },
     body: JSON.stringify(payload) }); if (!res.ok) { const err = await res.json().catch(() => ({}));
     alert(`Erreur: ${err.message || res.statusText}`); return; } alert('Réponse enregistrée !'); };
     
     const downloadData = async () => { const res = await fetch('https://survey-fop.group-cea.org/download');
     const blob = await res.blob(); const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = 'reponses.csv'; a.click(); };

      const handleNewForm = () => { setSubmitted(false); };
  return (
    <div className="container mt-5" translate = "no">
      
      <h2 className="text-center font-bold text-l 
      border-2 border-blue-500 rounded-md p-4 mb-6">
        Formulaire de Suivi-Evaluation <br/>CEA GROUPE SA
        <h6 style={{ backgroundColor: "yellow" }}>Les données saisies dans ce formulaire sont strictement
          confidentielles 🔒 et pour les besoins de CEA GROUPE SA.
          Ces données sont sécurisées, en envoyant ce formulaire,
          vous acceptez notre Charte de Confidentialité.
        </h6>
      </h2>
      
      {!submitted ? (
      <form onSubmit={handleSubmit} translate="no">

        <label>Nom :</label>
          <input type="text" className="form-control mb-2" name="nomEmploye" value={formData.nomEmploye} onChange={handleChange}/>
        <label>Prénom(s) :</label>

          <input type="text" className="form-control mb-2" name="prenomEmploye" value={formData.prenomEmploye} onChange={handleChange}/>
        <label>Fonction :</label>
          <input type="text" className="form-control mb-2" name="fonctionEmploye" value={formData.fonctionEmploye} onChange={handleChange}/>
        <label><br/>À quelle direction appartenez-vous ? :</label>
        <input type="radio" name="direction" value="directionGenerale"  onChange={handleChange}/>  Direction Générale<br/>
        <input type="radio" name="direction" value="directionFop" onChange={handleChange}/>  Filiale Formation et études de projets (CEA-FoP)<br />
        {formData.direction === "directionFop" && (
        <div className="subform">
          <label>Précisez votre division : </label>
          <input type="radio" name="division" value="division1"  onChange={handleChange}/>  Division Formation et Accompagnement des Organisations (FAO)<br/>
          <input type="radio" name="division" value="division2" onChange={handleChange}/>  Division Agri Durable & Dev. communautaire (ADDevCom)<br />
          <input type="radio" name="division" value="division3" onChange={handleChange}/>  Division Environnement et Changement climatique (EC2)<br />
        
        </div>
      )}
        <RadioGroup  formData={formData} handleChange={handleChange} />
        <button type="submit" className="btn btn-primary">Envoyer</button>
        
      </form>
      ):
       ( <div> <h2>Formulaire envoyé ✅</h2> <button onClick={handleNewForm}>Remplir un nouveau formulaire</button> </div> )}
    </div>
  );
}

export default App;
